import Login from 'pages/auth/Login/Login';
import ForgotPassword from 'pages/auth/ForgotPassword/ForgotPassword';
import Dashboard from 'pages/Dashboard/Dashboard';
import Accounts from 'pages/Accounts/Accounts';
import Bookings from 'pages/Bookings/Bookings';
import BookingDetails from 'pages/BookingDetails/BookingDetails';
import NewBooking from 'pages/NewBooking/NewBooking';
import PrivateCremation from 'pages/NewBooking/PrivateCremation/PrivateCremation';
import ManagePractice from 'pages/ManagePractice/ManagePractice';
import CustomerSupport from 'pages/CustomerSupport/CustomerSupport';
import TaggingGuide from 'pages/TaggingGuide/TaggingGuide';
import Profile from 'pages/Profile/Profile';
import NotFoundPage from 'pages/404';
import Referral from 'pages/NewBooking/Referral/Referral';
import VetUnityPrivateCremation from 'pages/NewBooking/VetUnity/PrivateCremation/PrivateCremation';
import VetUnityCommunal from 'pages/NewBooking/VetUnity/Communal/Communal';
import Package from 'pages/NewBooking/Package/Package';
import Communal from 'pages/NewBooking/Communal/Communal';
import UrnsAndMemorabilia from 'pages/NewBooking/UrnsAndMemorabilia/UrnsAndMemorabilia';
import VetSupply from 'pages/NewBooking/VetSupply/VetSupply';
import ViewMember from 'pages/ManagePractice/ViewMember/ViewMember';
import NewMember from 'pages/ManagePractice/NewMember/NewMember';
import UpdatePassword from 'pages/ManagePractice/UpdatePassword/UpdatePassword';
import EngravingLogin from 'pages/Engraving/EngravingLogin/EngravingLogin';
import EngravingExisting from 'pages/Engraving/EngravingExisting/EngravingExisting';
import Engraving404 from 'pages/Engraving/Engraving404/Engraving404';
import EngravingThankYou from 'pages/Engraving/EngravingThankYou/EngravingThankYou';
import EngravingApproved from 'pages/Engraving/EngravingApproved/EngravingApproved';
import EngravingOptions from 'pages/Engraving/EngravingOptions/EngravingOptions';
import FinalApproval from 'pages/Engraving/FinalApproval/FinalApproval';
import CustomiseText from 'pages/Engraving/CustomiseText/CustomiseText';
import ImageOptions from 'pages/Engraving/ImageOptions/ImageOptions';

const routes = [
    {
        title: 'Login',
        path: '/login',
        exact: true,
        component: Login,
        restricted: false,
        clientRestricted: false
    },
    {
        title: 'Forgot Password',
        path: '/forgot-password',
        component: ForgotPassword,
        restricted: false,
        clientRestricted: false
    },
    {
        title: 'Dashboard',
        path: '/dashboard',
        component: Dashboard,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'Accounts',
        path: '/accounts',
        component: Accounts,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'Booking Detail',
        path: '/booking/:id',
        component: BookingDetails,
        restricted: false,
        clientRestricted: false
    },
    {
        title: 'View Bookings/Orders',
        path: '/bookings',
        component: Bookings,
        restricted: false,
        clientRestricted: false
    },
    {
        title: 'New Private Cremation',
        path: '/new-booking/private',
        component: PrivateCremation,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'Edit Private Cremation',
        path: '/edit-booking-private/:id',
        component: PrivateCremation,
        restricted: false,
        clientRestricted: false
    },
    {
        title: 'New Private Cremation Referral',
        path: '/new-booking/referral',
        component: Referral,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'Edit Private Cremation Referral',
        path: '/edit-booking-referral/:id',
        component: Referral,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'New Private Cremation Vet Unity',
        path: '/new-booking/vetunity-private',
        component: VetUnityPrivateCremation,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'Edit Private Cremation Vet Unity',
        path: '/edit-booking-vetunity-private/:id',
        component: VetUnityPrivateCremation,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'New Communal Cremation Vet Unity',
        path: '/new-booking/vetunity-communal',
        component: VetUnityCommunal,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'Edit Communal Cremation Vet Unity',
        path: '/edit-booking-vetunity-communal/:id',
        component: VetUnityCommunal,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'New Private Cremation Package',
        path: '/new-booking/package',
        component: Package,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'Edit Private Cremation Package',
        path: '/edit-booking-package/:id',
        component: Package,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'Communal Booking',
        path: '/new-booking/communal',
        component: Communal,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'Edit Communal Booking',
        path: '/edit-booking-communal/:id',
        component: Communal,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'Urns and Memorabilia',
        path: '/new-booking/urns-and-memorabilia',
        component: UrnsAndMemorabilia,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'Edit Urns and Memorabilia',
        path: '/edit-booking-urns-and-memorabilia/:id',
        component: UrnsAndMemorabilia,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'Vet Supply Order',
        path: '/new-booking/vet-supply-order',
        component: VetSupply,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'New Booking',
        path: '/new-booking',
        component: NewBooking,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'Tagging Guide',
        path: '/tagging-guide',
        component: TaggingGuide,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'Customer Support',
        path: '/customer-support',
        component: CustomerSupport,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'View Member',
        path: '/manage-practice/view-member/:id',
        component: ViewMember,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'New Member',
        path: '/manage-practice/new-member',
        component: NewMember,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'Update Password',
        path: '/manage-practice/update-password',
        component: UpdatePassword,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'Manage Practice',
        path: '/manage-practice',
        component: ManagePractice,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'Profile',
        path: '/profile',
        component: Profile,
        restricted: true,
        clientRestricted: false
    },
    {
        title: 'Engraving Login',
        path: '/engraving/verify/:bookingId/:quotedProductId',
        component: EngravingLogin,
        restricted: false,
        clientRestricted: false
    },
    {
        title: 'Login',
        path: '/engraving/staff-login/:bookingId/:quotedProductId',
        component: Login,
        restricted: false,
        clientRestricted: false
    },
    {
        title: 'Engraving Not Available',
        path: '/engraving/404',
        component: Engraving404,
        restricted: false,
        clientRestricted: false
    },
    {
        title: 'Thank You',
        path: '/engraving/thank-you',
        component: EngravingThankYou,
        restricted: true,
        clientRestricted: true
    },
    {
        title: 'Engraving Approved',
        path: '/engraving/approved',
        component: EngravingApproved,
        restricted: true,
        clientRestricted: true
    },
    {
        title: 'Check Existing Artwork',
        path: '/engraving/check-existing',
        component: EngravingExisting,
        restricted: false,
        clientRestricted: false
    },
    {
        title: 'Customise Text',
        path: '/engraving/customise-text',
        component: CustomiseText,
        restricted: true,
        clientRestricted: true
    },
    {
        title: 'Engraving Options',
        path: '/engraving/engraving-options',
        component: EngravingOptions,
        restricted: true,
        clientRestricted: true
    },
    {
        title: 'Image Options',
        path: '/engraving/image-options',
        component: ImageOptions,
        restricted: true,
        clientRestricted: true
    },
    {
        title: 'Final Approval',
        path: '/engraving/final-approval',
        component: FinalApproval,
        restricted: true,
        clientRestricted: true
    },
    {
        title: '404',
        path: '*',
        component: NotFoundPage,
        restricted: false,
        clientRestricted: false
    }
];

export default routes;
